/**
 * Sawyer 03 today-notes-board (A4) — "does this dog get lunch today?" for the
 * morning board's LUNCH tag and "Lunches today" block.
 *
 * Sawyer (memo 3, 01:01, cleaned-up transcription): "these are the going home
 * dogs, but then these are the lunches also … add lunches to the morning
 * board"; Ted asked for the same list on 10-09 (#1219, "we feed two or five
 * dogs at noon"). Lunches are for daycare dogs, "not boarding" (memo 1,
 * 04:01), so a boarding visit is never lunch-marked here.
 *
 * The ONLY structured lunch fact on main is a daycare visit that already
 * carries the tenant's meal-charge add-on (House Food, `is_meal_charge`, read
 * from /today as `addOnIsMealCharge` on the leg). That is a BILLING flag, so
 * nothing in this lane tells the desk to add it to mark lunch (refuter C-4:
 * adding the leg would charge the owner). Until lane 08 ships the per-dog
 * marker, a tenant that does not use the add-on on daycare sees "No lunches
 * marked for today." — the honest answer.
 *
 * TODO(Sawyer lane 08 meds-feeding / #1219): OR in the per-dog "gets lunch at
 * daycare" marker and the per-booking override once /today carries them
 * (lane 08's `eatsLunch`, the last item key). Until then the meal-charge
 * add-on on a daycare visit is the only structured lunch fact on main.
 */
import type { DashboardArrival } from './dashboard-api.js';
import type { VisitWithLegs } from './service-legs.js';

/** Daycare, including the half day (`daycare-half` shares the daycare pool). */
function isDaycare(serviceType: string): boolean {
  return /^daycare(\b|-)/i.test(serviceType.trim());
}

/**
 * A visit (with its folded service legs) gets lunch today when it is a
 * daycare visit and the visit or one of its legs is the meal charge.
 */
export function lunchTodayFor(entry: VisitWithLegs<DashboardArrival>): boolean {
  if (entry.orphanLeg) return false;
  if (!isDaycare(entry.row.serviceType)) return false;
  return [entry.row, ...entry.legs].some((r) => r.addOnIsMealCharge === true);
}
